import useCategoriesBrands from '@hooks/useCategoriesBrands.main'
import CategoryCPG from '@page-components/Order/LongOrCompactCPG/Categories/CategoryCPG'
import BrandBar from '@page-components/Order/Products/ProductsContent/BrandBar'
import NoBrandDivider from '@page-components/Order/Products/ProductsContent/NoBrandDivider'
import useLayout from '@page-components/Order/useLayout'
import useProductsLayout from '@page-components/Order/useProductsLayout'
import React, {Fragment} from 'react'

export default function MultiBrandCategoryCPG(props) {
  const {website, categories, categoryRef, menuId, storeId, deliverAt, shouldHidePrice, sorting} =
    props

  const productsLayout = useProductsLayout(website)
  const layout = useLayout()
  const categoriesWithBrands = useCategoriesBrands(website._id)

  if (!categoriesWithBrands) return null

  let lastBrandId = null

  const getEmptyCategoryId = () => {
    for (const category of categories?.items || []) {
      if (!category.products.length) {
        return category._id
      }
    }
  }

  const emptyCategoryId = getEmptyCategoryId()

  const components = categoriesWithBrands?.items?.map(category => {
    if (emptyCategoryId === category._id) return null

    let brand = null
    if (category.brand && category.brand._id !== lastBrandId) {
      brand = category.brand
      lastBrandId = brand._id
    }

    const dividerContent =
      !category.brand && lastBrandId ? <NoBrandDivider key={category._id} /> : null
    const brandContent = brand ? <BrandBar brand={brand} key={category._id} /> : null

    if (!category.brand && lastBrandId) {
      lastBrandId = null
    }

    return (
      <Fragment key={category._id}>
        {brandContent}
        {dividerContent}
        <div
          ref={ref => {
            categoryRef.current[category._id] = ref
          }}
        >
          <CategoryCPG
            productsLayout={productsLayout}
            layout={layout}
            categoryId={category._id}
            menuId={menuId}
            hidePrice={shouldHidePrice}
            sorting={sorting}
            storeId={storeId}
            deliverAt={deliverAt}
          />
        </div>
      </Fragment>
    )
  })

  return <>{components}</>
}
